import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { PATHS } from "@/lib/router";
import SurveyResponseDetail from "../components/SurveyResponseDetail";

const SurveyResponseDetailPage = () => {
  const { t } = useTran();
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col">
      <header className="rounded-t-xl bg-gradient-to-tl from-nxstart-green to-nxstart-blue p-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-2xl font-semibold text-foreground text-white">
              {t("Survey Response")}
            </h1>
            <p className="mt-2 text-sm text-muted-foreground text-white">
              {t("Detailed scores and per-question breakdown.")}
            </p>
          </div>
        </div>
      </header>

      <main className="flex-1 space-y-6 overflow-y-auto p-6 nx-scroll bg-slate-50 dark:bg-[#101F42]">
        <Button
          type="button"
          variant="outline"
          onClick={() => navigate(PATHS.SURVEYS)}
          className="gap-2 rounded-full"
        >
          <ArrowLeft className="h-4 w-4" />
          {t("Back to Surveys")}
        </Button>

        <SurveyResponseDetail />
      </main>
    </div>
  );
};

export default SurveyResponseDetailPage;
